import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row pb-50px" }
const _hoisted_2 = { class: "ml-135px <lg:ml-50px <sm:ml-30px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flying_span = _resolveComponent("flying-span")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_flying_span, {
        block: "",
        timeout: 300,
        class: "text-72px <lg:text-36px font-500 gold-text-gradient"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("20+")
        ])),
        _: 1
      }),
      _createVNode(_component_flying_span, {
        block: "",
        timeout: 600,
        class: "text-white mt-10px text-22px <lg:text-14px <sm:text-12px"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" банков являются"),
          _createElementVNode("br", null, null, -1),
          _createTextVNode("нашими партнерами ")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_flying_span, {
        block: "",
        timeout: 900,
        class: "text-72px <lg:text-36px uppercase font-500 gold-text-gradient"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" топ 5 ")
        ])),
        _: 1
      }),
      _createVNode(_component_flying_span, {
        block: "",
        timeout: 1200,
        class: "text-white mt-10px text-22px <lg:text-14px <sm:text-12px"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" являемся одной из самых"),
          _createElementVNode("br", null, null, -1),
          _createTextVNode("крупных площадок России ")
        ])),
        _: 1
      })
    ])
  ]))
}